














































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
import { ReportLayout } from '../models/reportLayout';

@Component
export default class ReportLayoutVue extends Vue {
  public items: Common.ReportLayout[] = new Array();
  public params: Common.ReportLayoutQuery = new Common.ReportLayoutQuery();
  public tabVisibles: Array<boolean> = [true, true, true];
  @Prop() public templateId:number;

  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'viewName', text: '表示画面' },
    { value: 'id', text: 'ID' },
    { value: 'template', text: '帳票テンプレート' },
  ];
  public created(){
    if(this.templateId) this.params.templateId = this.templateId;
  }

  public onMoveToTemplate() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.ReportLayout;
    this.$router.push('/system/ReportTemplate?id=' + obj.template.id);
  }
  public isEditable(state: Common.ApprovalStatus){
    return state != Common.ApprovalStatus.Approved;
  }
  public onSelected(index: number,selected :any) {
    //レイアウト2タブの表示制御
    // this.onMultiLayoutChanged(this.items[index]);
     this.onMultiLayoutChanged(selected);
  }

  public onMultiLayoutChanged(item: ReportLayout) {
    //レイアウト2タブの表示制御
    this.$set(this.tabVisibles, 2, item.multiLayout);
  }
}
